import { Badge } from "design-system/atoms/Badge"
import { cn } from "design-system/utils"
import { useTranslation } from "react-i18next"
import {
  getCapabilityExecutionAppearance,
  getCapabilityExecutionIcon,
  MessageCapabilityExecution,
} from "./capabilityExecutionPresentation"

type Props = { execution: MessageCapabilityExecution }

const statusLabelKeys = {
  Success: "success",
  Unsuccess: "unsuccess",
  Cached: "cached",
  Error: "error",
  Skipped: "skipped",
} as const

export function CapabilityExecutionSummary({ execution }: Props) {
  const { t } = useTranslation()
  const KindIcon = getCapabilityExecutionIcon(execution.capabilityKind)
  const { textColorClass, badgeVariant } = getCapabilityExecutionAppearance(execution.status)

  return (
    <div className="flex w-full items-center justify-between gap-2">
      <div className="flex min-w-0 items-center gap-1.5">
        <KindIcon className={cn("size-4 shrink-0", textColorClass)} />
        <span className={cn("truncate text-sm font-medium", textColorClass)}>
          {execution.capabilityName ?? execution.capabilityIdentifier}
        </span>
      </div>
      <Badge variant={badgeVariant} className="shrink-0 text-xs">
        {t(`conversations.chat.capabilityExecutions.${statusLabelKeys[execution.status]}`)}
      </Badge>
    </div>
  )
}
